import { push } from 'connected-react-router'
import React from 'react'
import { useDispatch } from 'react-redux'
import { APPLICATION_MODE_NEW, APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE, ROUTE_PATH } from '../../app/constants'
import { replaceUrlParams } from '../../app/utils'
import { Button, Paragraph } from '../../components/RegularComponents'

export const MraPaymentConfirmation = () => {

    const dispatch = useDispatch()
    const applicationType = APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE
    const applicationMode = APPLICATION_MODE_NEW

    const whatHappensNextString = `It will take up to 10 business days to process your licence application. Business Licensing at Service Nova Scotia
                                    and Internal Services will contact you if any additional information is required. Once your licences are approved,
                                    you will receive an email notification to invite you to return to this service to view your licence.`
    const changeSomethingString = `If you have to change information to your submitted applications, contact Business Licensing at mortgageregulation@novascotia.ca`
    const managingApplicationString = `Continue to the service home page to see your application status and apply for more licences.
                                        From the home page you can cancel any existing licences, apply for mortgage broker and associate mortgage broker licences
                                        and download pdf copies of your licences.`

    return (
    <div className="container">
        <div className="row topMarginNormal">
            <h1>
                <span className="has-success" style={{marginRight: "5px"}}>
                    <i className="fa fa-check-circle"/>
                </span>
                Your application was submitted for review
            </h1>
        </div>

        <div className="row">
            <div className="col-lg-8">
                <h3>What happens next:</h3>
                <Paragraph 
                    id="payment-confirmation-what-happens-next-para"
                    text={[whatHappensNextString]}
                />
            </div>
        </div>

        <div className="row">
            <div className="col-lg-8">
                <h3>How to change something on an application you submitted:</h3>
                <Paragraph 
                    id="payment-confirmation-change-something-para"
                    text={[changeSomethingString]}
                />
            </div>
        </div>

        <div className="row">
            <div className="col-lg-8">
                <h3>Managing your applications and licences online:</h3>
                <Paragraph 
                    id="payment-confirmation-manage-applications-para"
                    text={[managingApplicationString]}
                />
            </div>
        </div>

        <div className="row topMarginMedium">
            <div className="col-lg-2">
                <Button 
                    id="payment-confirmation-go-home-button"
                    buttonType="regular_primary"
                    text="Go to home page"
                    onClick={() => {
                        dispatch(push(replaceUrlParams(
                            ROUTE_PATH.WELCOME, 
                            applicationType, 
                            applicationMode
                        )))
                    }}
                />
            </div>
        </div>
    </div>
    )
}